import * as Sentry from '@sentry/gatsby'
import { isChunkError, isHtmlServedAsScript } from './src/utils/chunkReload'

Sentry.init({
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Solo adjunta el documento de la operación; las variables no se envían.
    Sentry.graphqlClientIntegration({
      endpoints: [process.env.MIDDLE_END_URL].filter(Boolean),
    }),
  ],
  // El endpoint de Apollo va primero para que la traza llegue al backend en
  // cualquier ambiente, aunque su host no esté en la lista fija.
  tracePropagationTargets: [
    ...[process.env.MIDDLE_END_URL].filter(Boolean),
    'graphql.okyapp.com',
    'qa-graphql-backend.okyapp.com',
    'dev-co.okyapp.com',
    'co.okyapp.com',
    /^\//,
  ],
  enabled: process.env.SENTRY_ENABLED === 'TRUE',
  dsn: process.env.SENTRY_DSN_KEY,
  environment: process.env.SENTRY_ENVIRONMENT,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  tracesSampleRate: parseFloat(process.env.SENTRY_SAMPLE_TRACE),
  replaysSessionSampleRate: parseFloat(process.env.SENTRY_REPLAYSSESSION),
  replaysOnErrorSampleRate: parseFloat(process.env.SENTRY_REPLAYSON),
  debug: process.env.SENTRY_DEBUG === 'TRUE',
  // Cada operación GraphQL es una transacción (src/utils/sentryApolloLink.js)
  // y el SDK les adjunta los breadcrumbs, que solo se leen en los errores.
  beforeSendTransaction(event) {
    delete event.breadcrumbs
    return event
  },
  // El handler global del SDK captura estos errores antes que los listeners de
  // gatsby-browser.js y descarta la segunda captura, así que se etiquetan aquí:
  // los fallos de carga de chunks tras un deploy quedan en un solo issue.
  beforeSend(event, hint) {
    const error = hint?.originalException
    const frames = event.exception?.values?.[0]?.stacktrace?.frames
    const filename = frames?.[frames.length - 1]?.filename

    if (isChunkError(error) || isHtmlServedAsScript(error, filename)) {
      event.tags = { ...event.tags, chunkLoadError: true }
      event.fingerprint = ['chunk-load-error']
    }

    return event
  },
})
